import { LanguagesEnum } from '@/api/enums';
import { CampaignStatusesEnum } from './campaign.type';
import { CampaignPhishingSignEnum } from './campaigns.type';

export enum CatalogueUsageFilterEnum {
  SHOW_UNUSED = 'show-unused',
  SHOW_ALL = 'show-all',
  SHOW_USED = 'show-used',
}

export type CampaignCatalogueItem = {
  id: string;
  name: string;
  description?: string | null;
  thumbnailUrl?: string | null;
  phishingSign?: CampaignPhishingSignEnum | null;
  difficulty?: number | null;
  language?: LanguagesEnum | null;
  hasActiveSimulation?: boolean;
  simulationStatus?: CampaignStatusesEnum | null;
  benchmarkClickRate?: number | null;
  benchmarkSubmitRate?: number | null;
};

export type CampaignCatalogueResponse = {
  items: CampaignCatalogueItem[];
  total: number;
  skip: number;
  take: number;
};

export type GetCatalogueTemplatesParams = {
  usageFilter?: CatalogueUsageFilterEnum;
  filters?: any;
  take?: number;
  skip?: number;
  sort?: string[];
  sortNulls?: 'first' | 'last';
};
